import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'

import { AddErrorAlert, AddSuccessAlert } from '../../../../slices/alert'
import {
  fetchTypes,
  addType,
  deleteType,
  updateType
} from '../../../../slices/userType'

import NoPermissionContainer from '../../../../components/molecules/NoPermissionContainer'
import Add from '../../Controls/Add'
import Edit from '../../Controls/Edit'
import SettingsSection from '../../SettingsSection'

const CustomerTypeSettings = () => {
  const dispatch = useAppDispatch()
  const userTypes = useAppSelector(storeState => storeState.userType)
  const [saving, setSaving] = React.useState(false)

  React.useEffect(() => {
    if (!userTypes.loaded && !userTypes.loading) {
      dispatch(fetchTypes())
    }
  }, [userTypes, dispatch])

  const handleAddType = React.useCallback(
    async (name, external) => {
      try {
        setSaving(true)
        await dispatch(addType(name, external))
        dispatch(AddSuccessAlert('Changes saved'))
      } catch (err) {
        dispatch(AddErrorAlert({ err }))
        console.error(err)
      } finally {
        setSaving(false)
      }
    },
    [dispatch]
  )

  const handleDeleteType = React.useCallback(
    obj => {
      try {
        dispatch(deleteType(obj.id))
        dispatch(AddSuccessAlert('Changes saved'))
      } catch (err) {
        dispatch(AddErrorAlert({ err }))
        console.error(err)
      }
    },
    [dispatch]
  )

  const handleEditType = React.useCallback(
    async (obj, name, external) => {
      try {
        dispatch(updateType(obj.id, name, external))
        dispatch(AddSuccessAlert('Changes saved'))
      } catch (err) {
        dispatch(AddErrorAlert({ err }))
        console.error(err)
      }
    },
    [dispatch]
  )

  return (
    <NoPermissionContainer skipAgentPage error={userTypes.error}>
      <SettingsSection title='Types' loaded={userTypes.loaded}>
        {userTypes.types.map(type => {
          return (
            <Edit
              key={type.id}
              obj={type}
              objType='type'
              superType='user'
              external={type.external}
              locked={type.locked}
              handleDelete={handleDeleteType}
              handleEdit={handleEditType}
            />
          )
        })}
        <Add
          superType='user'
          type='type'
          checkbox
          handleAdd={handleAddType}
          saving={saving}
        />
      </SettingsSection>
    </NoPermissionContainer>
  )
}
export default CustomerTypeSettings
